module.exports = `${require.publicPath}background.5cf7f8d5.jpeg`;